import { Button } from '@mui/material'

const SalaryInfo = () => {
  return (
    <div>
      SalaryInfo
      <Button
        size="small"
        variant="contained"
        color="secondary"
        onClick={() => {
          window.location.href = '/dashboard/app'
        }}
      >
        Back
      </Button>
    </div>
  )
}

export default SalaryInfo
